"use strict";

var Factory = require('rosie').Factory;

var Chance = require('chance');

var Alert = require('../alerts/Alert');

var users = Object.values(require('../config/users.json'));
var chance = new Chance(12345);
var variants = ['info', 'success', 'warning', 'error'];
var factory = Factory.define('alert').sequence('id').attrs({
  user_id: function user_id() {
    return users[chance.integer({
      min: 0,
      max: users.length - 1
    })].id;
  },
  text: function text() {
    return chance.sentence();
  },
  variant: function variant() {
    return chance.weighted(variants, [10, 5, 3, 2]);
  },
  unread: true,
  archived: function archived() {
    return chance.bool();
  }
}).after(function (obj) {
  var print_job = new Alert(obj);
  return print_job;
});
module.exports = factory;